<div class="row pb-5">
  <div class="col-lg-12">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div class="d-flex align-items-center gap-10">
        <span
          class="material-symbols-outlined blue-color"
          *ngIf="!isPDFExtract"
        >
          article
        </span>
        <h3 class="mb-0 h3-label">{{ "OSI_DETAILS.TITLE" | translate }}</h3>
      </div>
      <div
        class="expand-icon-wrapper"
        (click)="isOsiDetailsOpened = !isOsiDetailsOpened"
        *ngIf="!isPDFExtract"
      >
        <span class="material-symbols-outlined" [@rotate]="!isOsiDetailsOpened">
          expand_less
        </span>
      </div>
    </div>
  </div>
  <div class="col-lg-12" [@collapse]="!isOsiDetailsOpened">
    <div class="table-responsive" *ngIf="otherServiceInformation?.length">
      <table class="mb-0 table table-default">
        <thead>
          <tr>
            <th>{{ "OSI_DETAILS.TABLE.NAME" | translate }}</th>
            <th>{{ "OSI_DETAILS.TABLE.OSI_CODE" | translate }}</th>
            <th>{{ "OSI_DETAILS.TABLE.ACTION_CODE" | translate }}</th>
            <th>{{ "OSI_DETAILS.TABLE.TEXT" | translate }}</th>
            <th>{{ "OSI_DETAILS.TABLE.APPLY_TO" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let osi of otherServiceInformation; let idx = index"
            [class.expanded]="passengersExpanded[idx]"
          >
            <td>
              {{ "OSI_DETAILS.TABLE.OSI_LABEL" | translate }} {{ idx + 1 }}
            </td>
            <td>{{ osi.osiCode || "-" }}</td>
            <td>{{ osi.actionCode || "-" }}</td>
            <td>{{ osi.text }}</td>
            <td>
              <div *ngIf="!osi.passengerRef; else passengersTemaplte">
                {{ "OSI_DETAILS.TABLE.ALL" | translate }}
              </div>
              <ng-template #passengersTemaplte>
                <div
                  class="d-flex align-items-center justify-content-end gap-8"
                  *ngIf="osi.passengerRef"
                >
                  <div>
                    <ng-container
                      *ngFor="
                        let passRef of osi.passengerRef.split(' ');
                        first as first
                      "
                    >
                      <span *ngIf="!passengersExpanded[idx] && first">
                        {{ passengers | getPassengerNameByRefPipe: passRef
                        }}{{
                          osi.passengerRef.split(" ").length > 1 && first
                            ? ", ..."
                            : ""
                        }}
                      </span>
                      <div class="text-justify" *ngIf="passengersExpanded[idx]">
                        {{ passengers | getPassengerNameByRefPipe: passRef }}
                      </div>
                    </ng-container>
                  </div>
                  <button
                    class="btn btn-secondary align-self-baseline py-1"
                    *ngIf="osi.passengerRef.split(' ').length > 1"
                    (click)="passengersExpanded[idx] = !passengersExpanded[idx]"
                  >
                    <i
                      class="fa fs-10"
                      [ngClass]="
                        !passengersExpanded[idx] ? 'fa-plus' : 'fa-minus'
                      "
                    ></i>
                  </button>
                </div>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="form-row mt-3" [class.mt-3]="otherServiceInformation?.length">
      <div class="col">
        <button
          class="btn btn-tonal-primary"
          [title]="'BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.ADD_HINT' | translate"
          (click)="openOsiModal(addOsiModal)"
        >
          <i class="fa fa-plus w-10 fs-10"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #addOsiModal let-d="dismiss">
  <div class="modal-header">
    <h3 class="modal-title">
      {{ "OSI_DETAILS.ADD_OSI_MODAL.TITLE" | translate }}
    </h3>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="d('close')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="osiForm">
      <div class="osi" formGroupName="osi">
        <ng-container
          *ngFor="
            let control of osiForm.get('osi')['controls'];
            let osiIdx = index;
            first as first
          "
          [formGroupName]="osiIdx"
        >
          <div class="d-flex align-items-center gap-15 mb-3">
            <div class="fs-16">
              {{ "BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.LABEL" | translate }}
              {{ otherServiceInformation.length + osiIdx + 1 }}
            </div>
            <i
              class="material-symbols-outlined remove-icon fs-18"
              [title]="
                'BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.REMOVE_HINT' | translate
              "
              (click)="removeOSI(osiIdx)"
            >
              delete
            </i>
          </div>
          <div class="form-row">
            <div class="form-group-sm col-md-2">
              <label>{{
                "BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.OSI_CODE.LABEL"
                  | translate
              }}</label>
              <input
                type="text"
                formControlName="osiCode"
                autocomplete="false"
                [placeholder]="
                  'BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.OSI_CODE.PLACEHOLDER'
                    | translate
                "
                class="form-control"
              />
            </div>

            <div class="form-group-sm col-md-2">
              <label>{{
                "BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.ACTION_CODE.LABEL"
                  | translate
              }}</label>
              <input
                type="text"
                formControlName="actionCode"
                autocomplete="false"
                [placeholder]="
                  'BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.ACTION_CODE.PLACEHOLDER'
                    | translate
                "
                class="form-control"
              />
            </div>

            <div class="form-group-sm col-md-8">
              <label>{{
                "BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.TEXT.LABEL" | translate
              }}</label>
              <input
                type="text"
                formControlName="text"
                autocomplete="false"
                [placeholder]="
                  'BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.TEXT.PLACEHOLDER'
                    | translate
                "
                class="form-control"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="col">
              <label>{{
                "BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.APPLY_TO.LABEL"
                  | translate
              }}</label>
              <div class="form-row">
                <div class="custom-col form-group-sm">
                  <div class="form-control">
                    <label class="checkbox custom-checkbox-1 mb-0">
                      <input
                        type="checkbox"
                        [checked]="applyOsiByPassengerTypeDisabled[osiIdx]"
                        (change)="
                          onPassengerRefChange(
                            control,
                            $event.target.checked,
                            osiIdx,
                            -1
                          )
                        "
                      />
                      <div class="checkbox__checkmark"></div>
                      <div class="checkbox__body fs-15">
                        {{
                          "BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.APPLY_TO.OPTIONS.ALL"
                            | translate
                        }}
                      </div>
                    </label>
                  </div>
                </div>
                <div class="vr mx-2 form-group-sm"></div>
                <ng-container
                  *ngFor="let passenger of passengers; let passengerIdx = index"
                >
                  <div class="custom-col form-group-sm">
                    <div
                      class="form-control"
                      [class.disabled]="applyOsiByPassengerTypeDisabled[osiIdx]"
                    >
                      <label class="checkbox custom-checkbox-1 mb-0">
                        <input
                          type="checkbox"
                          [checked]="
                            selectedPassengersPerOsi[osiIdx] &&
                            selectedPassengersPerOsi[osiIdx][passengerIdx] &&
                            !applyOsiByPassengerTypeDisabled[osiIdx]
                          "
                          (change)="
                            onPassengerRefChange(
                              control,
                              $event.target.checked,
                              osiIdx,
                              passengerIdx,
                              passenger.travelerReference
                            )
                          "
                        />
                        <div class="checkbox__checkmark"></div>
                        <div class="checkbox__body fs-15">
                          {{ passenger.data?.name }}
                          {{ passenger.data?.surname }}
                        </div>
                      </label>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="form-row">
        <div class="col">
          <button
            class="btn btn-tonal-primary"
            [title]="
              'BOOKING.STEPS.PAX.PASSENGERS.FORM.OSI.ADD_HINT' | translate
            "
            (click)="addOSI()"
          >
            <i class="fa fa-plus w-10 fs-10"></i>
          </button>
        </div>
      </div>
    </form>
    <div class="mt-4" *ngIf="orderUpdateProcess.isProcess">
      <app-show-processing
        [processInfo]="orderUpdateProcess.processTitle">
      </app-show-processing>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      data-dismiss="modal"
      (click)="d('close')"
    >
      {{ "BUTTONS.CLOSE" | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
      {{ "BUTTONS.SAVE" | translate }}
    </button>
  </div>
</ng-template>
